module.exports = __webpack_public_path__ + "img/nosolo-italia-belem.6096da5c.jpg";